var _defs, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#959595;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:bevel;stroke-width:1.6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,6a5.99792,5.99792,0,0,0,1.7568,4.2432,5.90456,5.90456,0,0,0,.9096.7464,6.05835,6.05835,0,0,0,1.0368.5544,6.00144,6.00144,0,0,0,6.54-1.3008,5.90456,5.90456,0,0,0,.7464-.9096,6.05835,6.05835,0,0,0,.5544-1.0368,6.00144,6.00144,0,0,0-1.3008-6.54,5.90456,5.90456,0,0,0-.9096-.7464A6.1492,6.1492,0,0,0,8.2968.456a6.00144,6.00144,0,0,0-6.54,1.3008,5.90456,5.90456,0,0,0-.7464.9096A6.1492,6.1492,0,0,0,.456,3.7032,6.0134,6.0134,0,0,0,0,6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.80005,
    y1: 6.00002,
    x2: 5.40005,
    y2: 8.40002
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.80005,
    y1: 6,
    x2: 5.40005,
    y2: 3.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightGray);
export default __webpack_public_path__ + "static/media/ic_arrow_right_gray.39ac68b10030aea927e44b12356ce34b.svg";
export { ForwardRef as ReactComponent };